import AppUserGuide from 'components/new_components/AppUserGuide';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { steps } from './steps';

import { Add, HelpOutline } from '@mui/icons-material';

//core components
import { Box, Button, ButtonGroup, CircularProgress, Divider, Menu, MenuItem } from '@mui/material';
import AppTable from 'components/new_components/app-table';
import AppTag from 'components/new_components/AppTags';
import RiskLevelsModal from './RiskLevelsModal';
import VendorDeleteModal from './VendorDeleteModal';
import VendorModal from './VendorModal';
import VendorsTableActions from './VendorsTableActions';
//redux
import { connect, useSelector } from 'react-redux';
import { GetAllVendors } from 'store/actions/vendorActions';

//utils
import { vendorResponseInitialValues, vendorsInitialValues } from '../../utils/constants';
import RiskWarning from '../../../../../assets/img/icons/Vendor-warning.svg';
// import { GetRemaining } from '../../../../../components/Pricing/usePricingHook';
// import AuthNotificationBar from "../../../AccountSetup/TwoFactorAuth/AuthNotificationBar";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { UserGuideContext } from 'store/context/UserGuideContextProvider';
//translations
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useTheme } from '@mui/material/styles';
import useSearch from 'hooks/useSearch';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Resolution, usePDF } from 'react-to-pdf';
import { GetFilteredVendors } from 'store/actions/vendorActions';
import DownloadQuestionnaireModal from './DownloadQuestionaire';
import SpoolVendorReport from './components/SpoolVendorReport';
import UploadCsv from './UploadCsvModal';
import UploadResponse from './UploadResponse';
import VendorDetailsModal from './VendorDetailsModal';
import VendorTitle from './VendorTitle';
import ResendQuestionnaireModal from './ResendQuestionnaireModal';
import { shortenString } from '../../utils/utils';
import { Typography } from '@mui/material';
import VendorTableRow from './components/VendorTableRow';
import AppTooltip from 'components/new_components/AppTooltip';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../../../../utils/https';

const NO_PER_PAGE = 8;

const vendorTableStyles = {
    container: {
        p: '0 !important',
        boxShadow: 'none',
    },
    tableWrapper: {
        p: 0,
        boxShadow: 'none',
    },
    tableTopbar: {
        pt: 5,
        px: '0 !important',
        alignItems: 'center',
        boxShadow: 'none',
    },
    tableHeader: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        p: 0,
        textOverflow: 'ellipsis',
        m: 0,
    },
    tableHeadCell: {
        borderBottom: '1px solid #E2E8F0 !important',
    },
};

const offScreenStyle = {
    position: 'absolute',
    left: '-9999px',
    top: 'auto',
    width: '800px',
    height: '85%',
    overflow: 'hidden',
    zIndex: -1,
};

const Vendors = (props) => {
    const { GetAllVendors, all_vendors, userguide_info, GetFilteredVendors, merchant_info } = props;
    const theme = useTheme();
    const [loading, setloading] = useState(false);

    const [page, setPage] = useState(1);
    const [pageData, setPageData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalUploadOpen, setModalUploadOpen] = useState(false);
    const [resendModalOpen, setResendModalOpen] = useState(false);
    const [modalDetailsOpen, setModalDetailsOpen] = useState(false);
    const [modalMode, setModalMode] = useState('');
    const [modalPayload, setModalPayload] = useState(vendorsInitialValues);
    const [modalPayloadId, setModalPayloadId] = useState(0);
    const [riskModalOpen, setRiskModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [openUserGuide, setOpenUserGuide] = useState(false);
    const [downloadQuestionaire, setDownloadQuestionaire] = useState(false);
    const [uploadResponse, setUploadResponse] = useState(false);
    const [responseDrawerPayload, setResponseDrawerPayload] = useState(vendorResponseInitialValues);
    const [activeVendor, setActiveVendor] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const [status, setStatus] = useState('');
    const [entity_type, setEntity_type] = useState('');

    // State for PDF Report Data & Loading
    const [vendorReportData, setVendorReportData] = useState(null);
    const [loadingReport, setLoadingReport] = useState(null);
    // const [reportError, setReportError] = useState(null);

    const location = useLocation();

    const openMenu = (e) => setAnchorEl(e.target);
    const closeMenu = () => setAnchorEl(null);

    const all_vendors_ = useMemo(
        () =>
            all_vendors?.filter((item) => {
                if (!status || status.toLowerCase() === 'all') return true;

                const hasResponded = item.questionnaire_history?.some((q) => q.has_responded);

                if (status.toLowerCase() === 'responded') return hasResponded;
                if (status.toLowerCase() === 'not responded') return !hasResponded;

                return true;
            }),
        [all_vendors, status]
    );
    const { data, handleSearch } = useSearch(all_vendors_, ['name', 'email', 'products']);
    //accessing values from the redux store
    const user_type = useSelector((state) => state?.authReducers?.user_type);
    const role = useSelector((state) => state?.generalReducers?.user_info?.role);
    //translation
    const { t } = useTranslation('vendorManagement');

    const stepsTargetRef = useRef([]);

    const { updateOneUserGuide, toggleUserGuide, setToggleUserGuide } = useContext(UserGuideContext);

    const { targetRef, toPDF } = usePDF({
        filename: `${merchant_info?.name + '-' || ''}vendor-report-${moment().format('MMM-DD-YYYY')}.pdf`,
        resolution: Resolution.LOW,
        page: {
            format: 'A4',
            margin: 12.5,
            orientation: 'portrait',
        },
        useCORS: true,
        onBeforeGetContent: async () => {
            await document.fonts.ready;
        },
        onAfterCapture: () => {
            setLoadingReport(null);
            setVendorReportData(null);
        },
    });

    //UserGuide
    const OpenUserGuide = () => {
        setOpenUserGuide(true);
    };
    const CloseUserGuide = () => {
        updateOneUserGuide({ vendors: true });
        setToggleUserGuide({ ...toggleUserGuide, vendors: false, actingasavendor: false });
        setOpenUserGuide(false);
    };

    const columns = [
        {
            title: t('table.column1'),

            render: (row) => {
                return parseInt(row?.latest_questionnaire_score) < parseInt(row?.min_risk_level) ? (
                    <AppTooltip
                        title={'This vendor is below minimum risk alert level'}
                        arrow
                        placement="bottom-start"
                        sx={{
                            '& .MuiTooltip-arrow': {
                                color: '#000',
                            },
                            '& .MuiTooltip-tooltip': {
                                backgroundColor: '#000',
                                color: '#fff',
                                p: 1,
                            },
                        }}
                    >
                        <div className="w-fit flex gap-1 cursor-pointer">
                            <img src={RiskWarning} />
                            <Typography sx={{ fontSize: '14px' }}>{row?.name}</Typography>
                        </div>
                    </AppTooltip>
                ) : (
                    <Typography sx={{ fontSize: '14px' }}>{row?.name}</Typography>
                );
            },
            width: '33.75%',
        },
        {
            title: t('table.column2'),
            key: 'description',
            render: (row) => <div className="pl-2">{shortenString(row?.description, 30)}</div>,
            width: '33.75%',
        },
        {
            title: (
                <div className="flex items-center">
                    {t('table.column3')}
                    <AppTooltip
                        title={
                            'Vendor risk level is based on the most recent questionnaire the vendor has responded to. This risk level reflects the potential negative impact the third-party vendor could have on your organization.'
                        }
                        arrow
                        placement="top"
                        sx={{
                            '& .MuiTooltip-arrow': {
                                color: '#000',
                            },
                            '& .MuiTooltip-tooltip': {
                                backgroundColor: '#000',
                                color: '#fff',
                                py: 1,
                                px: '8px',
                                width: '191px',
                                textAlign: 'center',
                            },
                        }}
                    >
                        <HelpOutline
                            sx={{
                                fontSize: '12px',
                                color: '#64748B',
                                ml: 1,
                            }}
                        />
                    </AppTooltip>
                </div>
            ),
            key: 'risk_level',
            render: (row) => {
                const riskLevel = row?.latest_questionnaire_risk_level;
                return (
                    <>
                        {riskLevel ? (
                            <>
                                {riskLevel?.toLowerCase() === 'low' ? (
                                    <AppTag
                                        text="Low"
                                        icon={
                                            <FiberManualRecordIcon
                                                sx={{
                                                    width: 12,
                                                    height: 12,
                                                    color: theme.palette.success[500],
                                                    mr: 0.5,
                                                }}
                                            />
                                        }
                                        type="default"
                                        noRounded
                                        noItalic
                                        sx={{
                                            padding: '4px 8px',
                                            borderColor: '#f1f5f9',
                                        }}
                                    />
                                ) : riskLevel?.toLowerCase() === 'medium' ? (
                                    <AppTag
                                        text="Medium"
                                        icon={
                                            <FiberManualRecordIcon
                                                sx={{
                                                    width: 12,
                                                    height: 12,
                                                    color: theme.palette.warning[900],
                                                    mr: 0.5,
                                                }}
                                            />
                                        }
                                        noRounded
                                        noItalic
                                        type="default"
                                        sx={{
                                            padding: '4px 8px',
                                            borderColor: '#f1f5f9',
                                        }}
                                    />
                                ) : riskLevel?.toLowerCase() === 'high' ? (
                                    <AppTag
                                        text="High"
                                        icon={
                                            <FiberManualRecordIcon
                                                sx={{ width: 12, height: 12, color: theme.palette.error[500], mr: 0.5 }}
                                            />
                                        }
                                        noRounded
                                        noItalic
                                        type="default"
                                        sx={{
                                            padding: '4px 8px',
                                            borderColor: '#f1f5f9',
                                        }}
                                    />
                                ) : (
                                    <span className="pl-4 inline-block ">---</span>
                                )}
                            </>
                        ) : (
                            <span className="pl-4 inline-block">---</span>
                        )}
                    </>
                );
            },
        },
        {
            title: <></>,
            align: 'center',
            key: 'action',
            render: (row) => (
                <>
                    <VendorsTableActions
                        row={row}
                        openModal={openModal}
                        openDeleteModal={openDeleteModal}
                        openDetailsModal={openDetailsModal}
                        openResendModal={() => openResendModal(row)}
                    />
                </>
            ),
            width: '30%',
        },
    ];

    //functions
    const handlePageChange = (page) => {
        setPage(page);
    };

    const closeModal = () => {
        setModalOpen(false);
        setTimeout(() => setModalPayload({}), 1000);
    };

    const openModal = (mode, payload = vendorsInitialValues, id) => {
        setModalOpen(true);
        setModalMode(mode);
        setModalPayload(payload);
        setModalPayloadId(id);
        closeMenu();
    };

    const openModalUpload = () => {
        setModalUploadOpen(true);
        closeMenu();
    };
    const closeModalUpload = () => {
        setModalUploadOpen(false);
    };

    const openUploadResponse = (payload = vendorResponseInitialValues) => {
        setUploadResponse(true);
        setResponseDrawerPayload(payload);
        closeMenu();
    };
    const closeUploadResponse = () => {
        setUploadResponse(false);
        setTimeout(() => setResponseDrawerPayload({}), 1000);
    };

    const openDownloadQuestionaire = () => {
        setDownloadQuestionaire(true);
        closeMenu();
    };

    const openResendModal = (vendor) => {
        setResendModalOpen(true);
        setActiveVendor(vendor);
    };
    const closeDownloadQuestionaire = () => {
        setDownloadQuestionaire(false);
    };
    const openRiskLevelsModal = () => {
        setRiskModalOpen(true);
    };
    const closeRiskLevelsModal = () => {
        setRiskModalOpen(false);
    };

    const openDetailsModal = (payload = {}) => {
        setModalDetailsOpen(true);
        setModalPayload(payload);
        closeMenu();
    };

    const closeDetailsModal = () => {
        setModalDetailsOpen(false);
    };

    const openDeleteModal = (id) => {
        setModalPayloadId(id);
        setDeleteModalOpen(true);
    };
    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setModalPayloadId(0);
    };
    const closeResendModal = () => {
        setResendModalOpen(false);
        setActiveVendor(null);
    };

    useEffect(() => {
        !userguide_info || toggleUserGuide.vendors ? OpenUserGuide() : null;
    }, [userguide_info, toggleUserGuide.vendors]);

    const query_params = useMemo(() => {
        const params = {
            ...(entity_type.length && { latest_risk_level: entity_type }),
        };
        return params;
    }, [entity_type]);

    const getAllVendors = async () => {
        setloading(true);
        const res = await GetAllVendors();
        setloading(false);
        if (!res?.success) {
            toast.error(res?.message);
        }
    };

    const getAllFilteredVendors = async () => {
        setloading(true);
        const res = await GetFilteredVendors(page, query_params);
        setloading(false);
        if (!res?.success) {
            toast.error(res?.message);
        }
    };

    useEffect(() => {
        if (query_params) {
            getAllFilteredVendors();
        } else {
            getAllVendors();
        }
    }, [query_params, page]);

    useEffect(() => {
        const start = (page - 1) * NO_PER_PAGE;
        const stop = start + NO_PER_PAGE;
        setPageData(data?.length ? data?.sort((a, b) => b?.id - a?.id)?.slice(start, stop) : []);

        return () => setPageData([]);
    }, [page, data]);

    useEffect(() => {
        if (location.state?.parent && location.state?.parent === 'vendors') {
            if (location.state.modalType) {
                switch (location.state.modalType) {
                    case 'newVendor':
                        openModal('add');
                        return;
                    case 'bulkVendors':
                        openModalUpload();
                        return;
                    case 'uploadQ':
                        openUploadResponse();
                        return;
                    default:
                        return;
                }
            }
        }
    }, [location]);

    /*  --- PDF Generation Logic --- */
    const generateSpoolReport = useCallback(
        async (e) => {
            e.preventDefault();
            if (!merchant_info?.id) {
                toast.error('Merchant information is missing.');
                return;
            }

            setLoadingReport(1);
            setVendorReportData(null);

            try {
                // 1. Fetch Data
                const response = await axiosInstance().post('/compliance/get_vendor_details/', {
                    merchant_id: merchant_info.id,
                });

                if (response?.data && response?.data?.vendor_data) {
                    // 2. Update State with Fetched Data
                    setVendorReportData(response.data);
                    setLoadingReport(2);

                    setTimeout(async () => {
                        try {
                            // 3. Generate PDF
                            await toPDF();
                            toast.success('Vendor Information exported successfully!');
                            setTimeout(() => {
                                closeMenu();
                            }, 100);
                        } catch (pdfError) {
                            console.error('Error generating PDF:', pdfError);
                            toast.error('Failed to generate PDF.');
                        } finally {
                            setLoadingReport(null);
                            setVendorReportData(null);
                        }
                    }, 500);
                } else {
                    throw new Error('Invalid report data received.');
                }
            } catch (error) {
                console.error('Error fetching vendor report:', error);
                const message =
                    error?.response?.data?.message || error?.message || 'Failed to fetch vendor report data.';
                toast.error(message);
                // setReportError(message);
                setLoadingReport(null);
            }
        },
        [merchant_info, toPDF]
    );

    return (
        <Box sx={{ mt: '3rem', mx: '1.3rem', backgroundColor: '#FFFFFF', px: '2rem' }}>
            {/*<div>
        {pricing_plan?.vendor_mgt !== all_vendors?.length && <AuthNotificationBar text="You have exceeded your number of users" />}
      </div>*/}
            <AppTable
                columns={columns}
                count={
                    <>
                        <strong>{loading ? '' : data?.length || ''}</strong>
                        {!loading && <span> {t('vendorCount')}</span>}
                    </>
                }
                RowComponent={VendorTableRow}
                data={pageData}
                implementer={'#F8FAFC'}
                loading={loading}
                sorter={(a, b) => b?.id - a?.id}
                colored_cell_color="#FFFBF3"
                title={
                    <VendorTitle
                        onSearch={handleSearch}
                        status={status}
                        entity_type={entity_type}
                        setStatus={setStatus}
                        setEntity_type={setEntity_type}
                    />
                }
                dataLength={data?.length}
                noPerPage={NO_PER_PAGE}
                page={page}
                border={true}
                borderStyles={{
                    borderSpacing: '0',
                    borderCollapse: 'separate',
                    borderRadius: '5px',
                    color: '#64748B',
                    p: 0,
                }}
                onPageChange={handlePageChange}
                sx={vendorTableStyles}
                actions={[
                    <ButtonGroup
                        sx={{
                            m: 0,
                            p: 0,
                            mr: '-32px',
                        }}
                        disabled={user_type === 'auditor' || role === 'auditor'}
                    >
                        <Button
                            startIcon={<Add />}
                            ref={(el) => (stepsTargetRef.current[0] = el)}
                            color="primary"
                            variant="contained"
                            // disabled={reminderCount === 0}
                            disableElevation
                            onClick={() => openModal('add')}
                            sx={{
                                display: 'flex-inline',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: '600',
                                // borderRadius: '4px',
                                py: 1.2,
                                px: 2.4,
                                m: 0,
                                textTransform: 'unset',
                                '&.Mui-disabled': {
                                    color: theme.palette.white.main,
                                    backgroundColor: theme.palette.gray[600],
                                },
                            }}
                        >
                            {t('table.addVendor')}
                        </Button>
                        <Button
                            onClick={openMenu}
                            color="primary"
                            variant="contained"
                            sx={{ borderLeft: '1px solid #5474C4', py: 1.2 }}
                        >
                            <KeyboardArrowDownIcon />
                        </Button>
                    </ButtonGroup>,
                ]}
            />
            <Menu
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={closeMenu}
                sx={{ mt: 2 }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: {
                        width: 'fit-content',
                    },
                }}
            >
                <MenuItem
                    onClick={openModalUpload}
                    sx={{ color: '#64748B', fontSize: '14px', fontWeight: 500, py: 0.2 }}
                >
                    {t('addVendorMenu.addBulkVendor')}
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={generateSpoolReport}
                    disabled={loadingReport !== null}
                    sx={{ color: '#64748B', fontSize: '14px', fontWeight: 500, py: 0.8 }}
                >
                    {loadingReport !== null && <CircularProgress size={18} sx={{ marginRight: 1 }} />}
                    {loadingReport === 1
                        ? 'Spooling info...'
                        : loadingReport === 2
                        ? 'Generating document...'
                        : t('addVendorMenu.exportVendor')}
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={openUploadResponse}
                    sx={{ color: '#64748B', fontSize: '14px', fontWeight: 500, py: 0.4 }}
                >
                    {t('addVendorMenu.uploadResponse')}
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={openDownloadQuestionaire}
                    sx={{ color: '#64748B', fontSize: '14px', fontWeight: 500, py: 0.4 }}
                >
                    {t('addVendorMenu.downloadQuestionaire')}
                </MenuItem>
            </Menu>
            <UploadCsv open={modalUploadOpen} handleClose={closeModalUpload} />
            <ResendQuestionnaireModal open={resendModalOpen} handleClose={closeResendModal} vendor={activeVendor} />

            <VendorModal
                open={modalOpen}
                handleClose={closeModal}
                isAddModal={modalMode === 'add'}
                payload={modalPayload}
                id={modalPayloadId}
                getAllVendors={getAllVendors}
                openRiskLevelsModal={openRiskLevelsModal}
            />
            <RiskLevelsModal open={riskModalOpen} handleClose={closeRiskLevelsModal} />

            <VendorDeleteModal
                open={deleteModalOpen}
                handleClose={closeDeleteModal}
                id={modalPayloadId}
                getAllVendors={getAllVendors}
            />
            <VendorDetailsModal
                open={modalDetailsOpen}
                handleClose={closeDetailsModal}
                details={modalPayload}
                getAllVendors={getAllVendors}
            />

            <AppUserGuide
                open={openUserGuide}
                onClose={CloseUserGuide}
                steps={steps}
                targets={stepsTargetRef.current}
            />

            <DownloadQuestionnaireModal open={downloadQuestionaire} handleClose={closeDownloadQuestionaire} />
            <UploadResponse
                vendors={all_vendors}
                open={uploadResponse}
                handleClose={closeUploadResponse}
                payload={responseDrawerPayload}
            />

            {/* Off-screen container for PDF report */}
            <Box sx={offScreenStyle}>
                {vendorReportData && <SpoolVendorReport targetRef={targetRef} vendorReport={vendorReportData} />}
            </Box>
        </Box>
    );
};

const mapStateToProps = (state) => {
    return {
        all_vendors: state?.vendorReducers?.all_vendors,
        pricing_plan: state?.authReducers.pricing_plan,
        userguide_info: state?.guideReducers?.userguide_info?.[0]?.vendors,
        merchant_info: state?.merchantReducers?.merchant_info,
    };
};

export default connect(mapStateToProps, { GetAllVendors, GetFilteredVendors })(Vendors);
